import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { LocalKeyMap } from '@/local';
import styles from './logo.module.scss'
import { useNavigate, useLocation } from 'react-router-dom';

const UserLogin = ({props}) => {
  const { t } = useTranslation();
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <div className={styles.logo}
    onClick={()=>{
      console.log(9999)
      navigate(`?tab=home`, {replace: true})
    }}></div>
  )
}

export default UserLogin
